// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H2w2","delete":"styles_delete__OmyKP","update":"styles_update__3k09Y","add":"styles_add__2x3mD"};